<template>
  <div class="imgViewframe">
    <div class="img_thumbnail_list">
      <div class="thumbnail_item" v-for="(item,index) in cusParam_thumbnailurlList">
        <img :src="item" alt="" v-if="index<8" @click="clickImg(index)">
      </div>
      <span class="view_more" v-if="cusParam_thumbnailurlList.length>8" @click="clickImg">查看更多</span>
      <div style="color: #999999" v-if="cusParam_thumbnailurlList.length === 0">暂无图片</div>
    </div>

    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        append-to-body
        custom-class="dialog_imgView"
    >
      <div class="dialog_conteng">
        <div class="img_index">{{imgIndex+1}}/{{cusParam_thumbnailurlList.length}}</div>
        <div class="img_content">
          <span class="tab_left kdfont kdfont-qianfan" @click="tabImg(-1)"></span>
          <div class="img_box">
            <transition name="el-zoom-in-center">
            <div style="position: relative" v-show="isLoadTrue">
              <img :src="cusParam_originalurlList[imgIndex]" alt="" @load="loadOriginImg" >
              <span class="img_close kdfont kdfont-guanbi6" @click="dialogVisible = false"></span>
            </div>
              </transition>
          </div>
          <span class="tab_right kdfont kdfont-houfan" @click="tabImg(1)"></span>
        </div>
        <div class="img_list" :class="{'img_list_noscroll':cusParam_thumbnailurlList.length <= 5}">
          <div class="img_item_box" :class="{'img_item_focus':index === imgIndex}" v-for="(item,index) in cusParam_thumbnailurlList">
            <div class="img_item"  @click="imgIndex = index">
              <img :src="item" alt="">
            </div>
          </div>
        </div>
        <div class="clearSroll"></div>
      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    invoke: Function,
    themeNum: String,
    lang: String,
    cusParam_thumbnailurlList:Array,
    cusParam_originalurlList:Array,
    cusParam_urlListForCheck:Array,
    isCheckDataChange:Boolean
  },
  computed: {},
  watch: {
    imgIndex:function (val){
      this.scrollThumbImgList(val)
    },
    cusParam_urlListForCheck:function (val){
      if(val.join() === this.cusParam_originalurlList.join()){
        this.showDialog()
      }else {
        this.invoke('form_dataChangeTip',true);
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      imgIndex: 0,
      isLoadTrue:false
    }
  },
  mounted() {

  },
  methods: {
    tabImg(num) {
      let newIndex = this.imgIndex + num;
      if (newIndex < 0) {
        this.imgIndex = 0;
      } else if (newIndex > this.cusParam_thumbnailurlList.length - 1) {
        this.imgIndex = this.cusParam_thumbnailurlList.length - 1;
      }else {
        this.imgIndex = newIndex;
      }
    },
    scrollThumbImgList(val){
      this.isLoadTrue = false;
      val = val +1;
      if((val - 2) > 0 && (val + 2) < this.cusParam_thumbnailurlList.length){
        let scrollNum = (val - 3) * 144
        $(".img_list").animate({scrollLeft: scrollNum + 'px'}, 200);
      }else if ((val - 2) <= 0){
        $(".img_list").animate({scrollLeft: 0 + 'px'}, 200);
      }else if((val + 2) >= this.cusParam_thumbnailurlList.length){
        $(".img_list").animate({scrollLeft: (this.cusParam_thumbnailurlList.length - 5) * 144  + 'px'}, 200);
      }
    },
    loadOriginImg(){
      this.isLoadTrue = true;
    },
    showDialog(index){
      if(typeof index === 'number')this.imgIndex = index;
      this.dialogVisible = true;
      this.scrollThumbImgList(this.imgIndex)
      this.loadOriginImg();
      console.log(this.imgIndex)
    },
    clickImg(index){
       if(this.isCheckDataChange){
         if(typeof index === 'number')this.imgIndex = index;
         this.invoke('form_getNewImgData',true);
       }else {
         this.showDialog(index)
       }
    }
  }
}
</script>
<style lang="less">
.imgViewframe {
   .img_thumbnail_list{
     display: flex;
     align-items: center;
     .thumbnail_item{
       img{
         margin-right: 8px;
         width: 40px;
         height: 30px;
         cursor: pointer;
       }
     }
     .view_more{
       color: #0E5FD8;
       cursor: pointer;
     }
   }
}

.dialog_imgView {
  border: 0 !important;
  background: none !important;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3) !important;
  margin-bottom: 0 !important;
  margin-top: calc(50vh - 330px) !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;
    border: 0 !important;

    .dialog_conteng {
      display: flex;
      flex-direction: column;
      align-items: center;

      .img_index {
        font-size: 16px;
        color: #FFF;
        font-weight: 500;
      }

      .img_content {
        display: flex;
        align-items: center;
        margin: 8px 0 20px;

        .tab_left, .tab_right {
          font-size: 48px;
          color: #FFF;
          cursor: pointer;
        }

        .img_box {
          position: relative;
          width: 800px;
          height: 533px;
          margin: 0 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            max-width: 800px;
            max-height: 533px;
          }

          .img_close {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background: #666;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 1px;
            position: absolute;
            font-size: 17px;
            font-weight: 600;
            color: #FFF;
            right: -14px;
            top: -14px;
            cursor: pointer;
          }
        }
      }

      .img_list {
        display: flex;
        align-items: center;
        width: 720px;
        overflow-y: scroll;

        .img_item_box{
          margin: 0 10px;
          padding: 2px;
          margin-bottom: 20px;
        }
        .img_item {
          width: 120px;
          height: 80px;
          flex-grow: 0;
          flex-shrink: 0;
          background: black;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: content-box;
          cursor: pointer;

          img {
            max-height: 80px;
            max-width: 120px;
          }
        }

        .img_item_focus{
          background: #5582F3;
        }
      }
      .img_list_noscroll{
        justify-content: center;
      }
      .clearSroll{
        height: 20px;
        width: 720px;
        background: transparent;
        margin-top: -20px;
        z-index: 0;
        background: gray;
      }
    }
  }

}
</style>